import {
  sortCurriculumTypesWithKFirst,
  getRelevantCourseList,
} from 'experienceComponents/CreateInstanceShared/dataUtils'
import {
  filterSmallGroupCurriculumTypes,
  convertGradeToDisplayValue,
  convertGradeNameToLabel,
  getProgramName,
  createViewClassBehavior,
} from './data'

// Filter and sort configuration
export const smallGroupFilterConfig = {
  filterFunction: filterSmallGroupCurriculumTypes,
  sortFunction: sortCurriculumTypesWithKFirst,
  getRelevantCourseList: courses => getRelevantCourseList(courses, true), // true = small groups
  convertGradeToDisplayValue: convertGradeToDisplayValue,
  isSmallGroup: true, // Explicit flag - don't rely on function name matching
}

// Program mapping configuration
export const smallGroupProgramConfig = {
  convertGradeNameToLabel: convertGradeNameToLabel,
  getProgramName: getProgramName,
}

// View class behavior configuration
export const smallGroupViewClassConfig = {
  createViewClassBehavior: createViewClassBehavior,
}

// Small group configuration
export const SMALL_GROUP_CONFIG = {
  schemaName: 'CREATESMALLGROUPSCHEMA',
  requiresSite: false,
  requiresDates: false,
  filterFunction: 'filterSmallGroupCurriculumTypes',
  sortFunction: 'sortCurriculumTypesWithKFirst',
  getRelevantCourseList: courses => getRelevantCourseList(courses, true), // true = small groups
  duplicateMessage: 'You may not have a duplicate small group name',
  validatorClass: 'CreateSmallGroupValidator',
  validationType: 'smallGroup',
}

// Legacy config for backward compatibility
export const smallGroupConfig = {
  ...smallGroupFilterConfig,
  ...smallGroupProgramConfig,
  ...smallGroupViewClassConfig,
}
